var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-number-field',{attrs:{"label":_vm.label || _vm.$t('common.priority'),"disabled":_vm.disabled,"loading":_vm.loading,"name":_vm.name,"min":_vm.min,"required":_vm.required},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }